import {pushNotificationTemplate as initialTemplate} from '../initialStates';

const GET_PUSH_NOTIFICATION_TEMPLATES_PENDING = 'GET_PUSH_NOTIFICATION_TEMPLATES_PENDING';
const GET_PUSH_NOTIFICATION_TEMPLATES_FULFILLED = 'GET_PUSH_NOTIFICATION_TEMPLATES_FULFILLED';
const GET_PUSH_NOTIFICATION_TEMPLATES_REJECTED = 'GET_PUSH_NOTIFICATION_TEMPLATES_REJECTED';

const GET_PUSH_NOTIFICATION_TEMPLATE_PENDING = 'GET_PUSH_NOTIFICATION_TEMPLATE_PENDING';
const GET_PUSH_NOTIFICATION_TEMPLATE_FULFILLED = 'GET_PUSH_NOTIFICATION_TEMPLATE_FULFILLED';
const GET_PUSH_NOTIFICATION_TEMPLATE_REJECTED = 'GET_PUSH_NOTIFICATION_TEMPLATE_REJECTED';

const POST_PUSH_NOTIFICATION_TEMPLATE_PENDING = 'POST_PUSH_NOTIFICATION_TEMPLATE_PENDING';
const POST_PUSH_NOTIFICATION_TEMPLATE_FULFILLED = 'POST_PUSH_NOTIFICATION_TEMPLATE_FULFILLED';
const POST_PUSH_NOTIFICATION_TEMPLATE_REJECTED = 'POST_PUSH_NOTIFICATION_TEMPLATE_REJECTED';

const DELETE_PUSH_NOTIFICATION_TEMPLATE_PENDING = 'DELETE_PUSH_NOTIFICATION_TEMPLATE_PENDING';
const DELETE_PUSH_NOTIFICATION_TEMPLATE_FULFILLED = 'DELETE_PUSH_NOTIFICATION_TEMPLATE_FULFILLED';
const DELETE_PUSH_NOTIFICATION_TEMPLATE_REJECTED = 'DELETE_PUSH_NOTIFICATION_TEMPLATE_REJECTED';

const POST_PUSH_NOTIFICATION_PENDING = 'POST_PUSH_NOTIFICATION_PENDING';
const POST_PUSH_NOTIFICATION_FULFILLED = 'POST_PUSH_NOTIFICATION_FULFILLED';
const POST_PUSH_NOTIFICATION_REJECTED = 'POST_PUSH_NOTIFICATION_REJECTED';

const GET_PUSH_NOTIFICATIONS_PENDING = 'GET_PUSH_NOTIFICATIONS_PENDING';
const GET_PUSH_NOTIFICATIONS_FULFILLED = 'GET_PUSH_NOTIFICATIONS_FULFILLED';
const GET_PUSH_NOTIFICATIONS_REJECTED = 'GET_PUSH_NOTIFICATIONS_REJECTED';

const GET_PUSH_NOTIFICATION_PENDING = 'GET_PUSH_NOTIFICATION_PENDING';
const GET_PUSH_NOTIFICATION_FULFILLED = 'GET_PUSH_NOTIFICATION_FULFILLED';
const GET_PUSH_NOTIFICATION_REJECTED = 'GET_PUSH_NOTIFICATION_REJECTED';

const initialState = {
  notification_templates: [],
  notification_template: initialTemplate,
  notifications: [],
  fetching: false,
  fetched: false,
  errors: {}
};

const applyLoadingState = state => ({
  ...state,
  fetching: true,
  fetched: false
});

const applyFetchedNotificationTemplates = (state, payLoad) => ({
  ...state,
  fetching: false,
  fetched: true,
  notification_templates: payLoad.data,
});

const applyFetchedNotifications = (state, payLoad) => ({
  ...state,
  fetching: false,
  fetched: true,
  notifications: payLoad.data,
});

const applyFetchedNotificationTemplate = (state, payLoad) => ({
  ...state,
  fetching: false,
  fetched: true,
  notification_template: payLoad.data,
});

const reject = state => ({
  ...state,
  fetching: false,
  fetched: true,
});

const applyDeleteNotificationTemplate = (state, id) => ({
  ...state,
  notification_templates: state.notification_templates.filter(template => template.id !== id),
  fetching: false,
  fetched: true,
});

const applyAddNotificationTemplate = (state, template) => ({
  ...state,
  notification_templates: [...state.notification_templates, template],
  fetching: false,
  fetched: true,
});

export default (state = initialState, action) => {
  switch (action.type) {
    case GET_PUSH_NOTIFICATION_TEMPLATE_PENDING:
    case GET_PUSH_NOTIFICATIONS_PENDING:
    case GET_PUSH_NOTIFICATION_TEMPLATES_PENDING: {
      return applyLoadingState(state);
    }
    case GET_PUSH_NOTIFICATION_TEMPLATES_FULFILLED: {
      return applyFetchedNotificationTemplates(state, action.payLoad);
    }
    case GET_PUSH_NOTIFICATION_TEMPLATE_FULFILLED: {
      return applyFetchedNotificationTemplate(state, action.payLoad);
    }
    case GET_PUSH_NOTIFICATIONS_FULFILLED: {
      return applyFetchedNotifications(state, action.payLoad);
    }
    case DELETE_PUSH_NOTIFICATION_TEMPLATE_FULFILLED: {
      return applyDeleteNotificationTemplate(state, action.payLoad);
    }
    case POST_PUSH_NOTIFICATION_TEMPLATE_FULFILLED: {
      return applyAddNotificationTemplate(state, action.payLoad.data);
    }
    case GET_PUSH_NOTIFICATION_TEMPLATE_REJECTED:
    case GET_PUSH_NOTIFICATION_TEMPLATES_REJECTED: {
      return reject(state);
    }
    default:
  }

  return state;
};

export {
  GET_PUSH_NOTIFICATION_TEMPLATES_FULFILLED,
  GET_PUSH_NOTIFICATION_TEMPLATES_PENDING,
  GET_PUSH_NOTIFICATION_TEMPLATES_REJECTED,
  GET_PUSH_NOTIFICATION_TEMPLATE_PENDING,
  GET_PUSH_NOTIFICATION_TEMPLATE_REJECTED,
  GET_PUSH_NOTIFICATION_TEMPLATE_FULFILLED,
  GET_PUSH_NOTIFICATIONS_PENDING,
  GET_PUSH_NOTIFICATIONS_FULFILLED,
  GET_PUSH_NOTIFICATIONS_REJECTED,
  GET_PUSH_NOTIFICATION_PENDING,
  GET_PUSH_NOTIFICATION_FULFILLED,
  GET_PUSH_NOTIFICATION_REJECTED,
  POST_PUSH_NOTIFICATION_FULFILLED,
  POST_PUSH_NOTIFICATION_PENDING,
  POST_PUSH_NOTIFICATION_REJECTED,
  POST_PUSH_NOTIFICATION_TEMPLATE_FULFILLED,
  POST_PUSH_NOTIFICATION_TEMPLATE_PENDING,
  POST_PUSH_NOTIFICATION_TEMPLATE_REJECTED,
  DELETE_PUSH_NOTIFICATION_TEMPLATE_FULFILLED,
  DELETE_PUSH_NOTIFICATION_TEMPLATE_PENDING,
  DELETE_PUSH_NOTIFICATION_TEMPLATE_REJECTED,
};
